import * as types from './constants'
import {process} from '@myxplor/payload-helpers'

const defaultState = {
  attributes: [],
  authorised_id: null,
  valid: false,
  loading: false,
  submitted: false,
  errors: {}
}

export const handleLoaded = (payload) => ({
  attributes: process(payload.attributes)
})

const assignAuthPerson = (payload) => ({
  authorised_id: payload.person_id,
  valid: !!payload.person_id
})

const handlePending = () => ({
  loading: true
})

const handleSuccess = () => ({
  submitted: true
})

export const authPeopleReducer = (state = defaultState, action) => {
  switch (action.type) {
  case types.AUTH_PERSONNEL_LOADED:
    return Object.assign(
      {},
      state,
      handleLoaded(action)
    )
    
  case types.AUTH_PERSON_ASSSIGNED:
    return Object.assign(
      {},
      state,
      assignAuthPerson(action)
    )

  case types.AUTH_PERSON_SUBMITTED_PENDING:
    return Object.assign(
      {},
      state,
      handlePending()
    )

  case types.AUTH_PERSON_SUBMITTED_SUCCESS:
    return Object.assign(
      {},
      state,
      handleSuccess(action)
    )
  default:
    return state
  }
}

export default authPeopleReducer


// WEBPACK FOOTER //
// ./src/auth-personnel/reducer.js